export function initMobileDropdown() {
  const dropdowns = document.querySelectorAll(
    '.main-menu ul.navigation li.dropdown'
  );

  dropdowns.forEach((dropdown) => {
    // Éviter doublons
    if (dropdown.querySelector('.righticon')) return;

    // Création du bouton
    const toggle = document.createElement('span');
    toggle.className = 'righticon';

    const icon = document.createElement('i');
    icon.className = 'pbmit-base-icon-down-open-big';

    toggle.appendChild(icon);
    dropdown.appendChild(toggle);

    toggle.addEventListener('click', (e) => {
      e.preventDefault();

      // 🔑 ÉQUIVALENT DE $(this).siblings()
      const siblings = Array.from(dropdown.children).filter(
        (child) => child !== toggle
      );

      siblings.forEach((el) => {
        el.classList.toggle('open');
      });

      // Toggle icône
      icon.classList.toggle('pbmit-base-icon-down-open-big');
      icon.classList.toggle('pbmit-base-icon-up-open-big');
    });
  });
}
